import { useEffect, useRef, useState } from "react";
import "./Button.scss";
import gsap from "gsap";
import { IMAGES } from "../../assets/media/images";

function Button({ description, onClick }) {
    const [isClick, setIsClick] = useState(false);
    const buttonRef = useRef(null);
    const timeline = useRef(null);

    useEffect(() => {
        if (isClick && buttonRef.current) {
            timeline.current = gsap.timeline({
                defaults: {
                    duration: .2,
                    ease: "power2.out",
                }
            })
                .to(buttonRef.current, {scaleY: .98, scaleX: .97, opacity: .7})
                .to(buttonRef.current, {scale: 1, opacity: 1, onComplete: () => setIsClick(false)})
            
            return () => timeline.current.kill();
        };
    }, [isClick]);

    const handleClick = () => {
        if (!isClick) {
            setIsClick(true);
            onClick()
        }
    }

    return (
        <div className="button-wrapper">
            <button className="button" style={{backgroundImage: `url(${IMAGES.button_background})`}} onClick={handleClick} ref={buttonRef}>
                {description}
            </button>
        </div>
    );
};

export default Button;